<template>
  <!-- 选择注册方式 -->
  <div class="father">
    <div class="fatherBox">
      <div class="lineNew"></div>
      <span class="fontNew">{{ $t('login.SelectRegistrationMethod') }}</span>
      <div class="lineNew"></div>
    </div>
    <div class="fatherBt">
      <div class="btBx" @click="fastRegister('phone')">
        <img class="icon" :src="$utils.getPng(`icon-login-newPhone`)" alt="" />
        <span
          :class="{
            btxFont: true,
            enBtxFont: $store.state.language == 'en',
          }"
          >{{ $t('login.PhoneRegistration') }}</span
        >
      </div>
      <div class="btBx" v-if="showPhone" @click="fastRegister('email')">
        <img class="icon" :src="$utils.getPng(`icon-login-newEmail`)" alt="" />
        <span
          :class="{
            btxFont: true,
            enBtxFont: $store.state.language == 'en',
          }"
          >{{ $t('login.EmailRegistration') }}</span
        >
      </div>
      <div class="btBx" v-if="showWx == 1" @click="fastRegister('wx')">
        <img class="icon" :src="$utils.getPng(`icon-login-newWx`)" alt="" />
        <span
          :class="{
            btxFont: true,
            enBtxFont: $store.state.language == 'en',
          }"
          >{{ $t('login.WeChatRegistration') }}</span
        >
      </div>
      <div class="btBx" @click="fastRegister('qq')">
        <img class="icon" :src="$utils.getPng(`icon-login-newQq`)" alt="" />
        <span
          :class="{
            btxFont: true,
            enBtxFont: $store.state.language == 'en',
          }"
          >{{ $t('login.QQRegistration') }}</span
        >
      </div>
      <div class="btBx" v-if="showGoogle" @click="fastRegister('google')">
        <img class="icon" :src="$utils.getPng(`register-google-icon`)" alt="" />
        <span
          :class="{
            btxFont: true,
            enBtxFont: $store.state.language == 'en',
          }"
          >{{ $t('login.GoogleRegistration') }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showPhone: true,
    showWx: {
      type: Number,
      default: 0,
    },
    showGoogle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    fastRegister(type) {
      this.$emit('fastRegister', type)
    },
  },
}
</script>

<style lang="scss" scoped>
.father {
  margin-top: 45px;
  .fatherBox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    .lineNew {
      // width: 140px;
      flex-grow: 1;
      height: 2px;
      background: #f6f6f6;
    }
    .fontNew {
      font-weight: 400;
      font-size: 14px;
      color: #8a8b92;
      line-height: 21px;
      margin: 0 9px;
    }
  }
  .fatherBt {
    .btBx {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 382px;
      height: 56px;
      border-radius: 28px;
      border: 2px solid #F6F6F6;
      margin-bottom: 16px;
      cursor: pointer;
      .icon {
        width: 28px;
        height: 28px;
        object-fit: cover;
        margin-right: 8px;
      }
      .btxFont {
        font-weight: 500;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 22px;
        // width: 70px;
        text-align: center;
        white-space: nowrap;
      }
      .enBtxFont {
        width: 136px !important;
      }
      &:hover {
        background: #F6F6F6;
      }
    }
  }
}
</style>
